import { Component, Inject } from '@angular/core';
import { PasswordActions } from '@tango/app/core/actions';
import {
  LocalizationService,
  NavigatorService,
} from '@tango/app/core/services';
import { APP_CONFIG } from '@tango/app/app.config';
import { AppConfig } from '@tango/app/interfaces';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: 'locked-page.component.html',
})
export class LockedPageComponent {
  locales;
  config: AppConfig;

  constructor(
    private goto: NavigatorService,
    private localizationService: LocalizationService,
    private translate: TranslateService,
    private passwordActions: PasswordActions,
    @Inject(APP_CONFIG) protected _config: AppConfig
  ) {
    this.config = _config;
    this.locales = { uk: 'uk', ru: 'ru', eng: 'eng' };
  }

  get locale(): string {
    return this.localizationService.currentLocale;
  }

  l10n(fieldName: string): string {
    return this.localizationService.getField(fieldName, 'lockedPage');
  }

  gotoLogin() {
    this.goto.login();
  }

  setLocale(locale: string) {
    this.localizationService.setLocale(locale);
    this.translate.use(locale);
  }

  resetPassword() {
    this.passwordActions.setRecoveryMode();
    this.goto.registration();
  }
}
